import React, { useRef } from 'react';
import {
    Box,
    Button,
    CloseButton,
    Flex,
    Heading,
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Text
} from '@chakra-ui/react';
import { useTranslate } from 'ts/common/hooks';
import { ReactComponent as CheckMarkIcon } from 'client_react/svg/check-mark.svg';

interface ViewInvoiceModalProps {
    isOpen: boolean;
    onClose: () => void;
    onViewInvoice: () => void;
}

const ViewInvoiceModal: React.FC<ViewInvoiceModalProps> = ({ isOpen, onClose, onViewInvoice }) => {
    const t = useTranslate('contract.viewInvoiceModal');
    const initialFocusRef = useRef<HTMLButtonElement>(null);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="xl"
            initialFocusRef={initialFocusRef}
            aria-labelledby="invoice-modal-title"
        >
            <ModalOverlay />
            <ModalContent borderRadius="16px" role="dialog" aria-modal="true">
                <ModalHeader
                    color="gray.500"
                    paddingY="24px"
                    paddingX="56px"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Heading
                        as="h3"
                        size="lg"
                        fontWeight="medium"
                        textAlign="center"
                        id="invoice-modal-title"
                    >
                        {t('signatureComplete')}
                    </Heading>
                    <CloseButton
                        onClick={onClose}
                        border="none"
                        color="gray.500"
                        _hover={{ color: 'brand.primary' }}
                        sx={{
                            '&:focus': {
                                color: 'gray.500'
                            },
                            transform: 'scale(1.2)'
                        }}
                        cursor="pointer"
                        boxSize={8}
                        aria-label={t('cancel')}
                    />
                </ModalHeader>
                <ModalBody
                    paddingTop="0"
                    paddingInlineStart="24px"
                    paddingInlineEnd="24px"
                    paddingBottom="32px"
                >
                    <Box textAlign="center">
                        <Box width="89px" height="68px" margin="24px auto" color="brand.primary">
                            <CheckMarkIcon aria-hidden="true" role="img" />
                        </Box>
                        <Text fontSize="16px" marginBottom="32px" color="gray.500">
                            {t('invoiceSigned')}
                        </Text>
                    </Box>
                    <Flex gap="16px">
                        <Button
                            onClick={onClose}
                            variant="outline primary"
                            width="100%"
                            cursor="pointer"
                        >
                            {t('cancel')}
                        </Button>
                        <Button
                            ref={initialFocusRef}
                            onClick={onViewInvoice}
                            variant="primary"
                            width="100%"
                            cursor="pointer"
                        >
                            {t('viewInvoice')}
                        </Button>
                    </Flex>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default ViewInvoiceModal;
